import React, { useState, useEffect } from 'react';
import moment from "moment"

import { ContentBox } from '../ContentBox';
import { SingleSelect } from '../../Res/BaseInput';
import { DailyWageMonthly_Fixed, DailyWageMonthlyAttr, ReqContractorAttendance, ContractorAttendanceInfo_SalaryMonthly } from '../../../../item/ItemContractorAttendance';
import { DailogHtml } from '../../../DailogHtml';
import { ContractorAttendanceDailogOvertimePay } from './ContractorAttendanceDailogOvertimePay';
import { CancelSubmitButton, CancelButton, SubmitButton } from '../../Res/BaseButton';
import { ContractorAttendanceDailogAttendanceDay } from './ContractorAttendanceDailogAttendanceDay';
import {ContractorAttendanceDailogAbsenceAmout} from './ContractorAttendanceDailogAbsenceAmout'
import { useRef } from 'react';
import { ContractorAttendanceDailogSalaryAddAmount } from './ContractorAttendanceDailogSalaryAddAmount';
import { ContractorAttendanceDailogSalarySubtractAmount } from './ContractorAttendanceDailogSalarySubtractAmount';
import { ReqRecruitmentItem_SalaryMonthly } from '../../../../item/ItemContractorAttendance_RecruitmentItem_SalaryMonthly';

export function ContractorAttendanceRegisterMonthlyRecruitmentList({ recruitmentList, contractorAttendance, toSave, getContractor }) {
    const [mReqContractorAttendance, setContractorAttendance] = useState(new ReqContractorAttendance({}))
    const [RecruitmentList, setRecruitmentList] = useState([])
    const [DailyWageMonthly, setDailyWageMonthly] = useState(DailyWageMonthly_Fixed)

    const [dialogTitle, setDialogTitle] = useState(<></>)
    const [dialogContent, setDialogContent] = useState(<></>)
    const [dialogAction, setDialogAction] = useState(<></>)
    const [open, setOpen] = React.useState(false);

    const [MonthlySalaryAmount, setMonthlySalaryAmount] = useState(0)
    const [AttendanceDayAmount, setAttendanceDayAmount] = useState(0)
    const [OvertimePayAmount, setOvertimePayAmount] = useState(0)
    const [AbsenceAmout, setAbsenceAmout] = useState(0)
    const [SalaryAddAmount, setSalaryAddAmount] = useState(0)
    const [SalarySubtractAmount, setSalarySubtractAmount] = useState(0)
    const [SalaryAmount, setSalaryAmount] = useState(0)
    const [PreServiceFeeAmount, setPreServiceFeeAmount] = useState(0)

    const [isCalculate, setCalculateAmount] = useState(false)

    // const handleClickOpen = (scrollType) => () => {
    //     setOpen(true);
    //     setScroll(scrollType);
    // };

    // const handleClose = () => {
    //     setOpen(false);
    // };

    // const descriptionElementRef = React.useRef(null);
    // React.useEffect(() => {
    //     if (open) {
    //         const { current: descriptionElement } = descriptionElementRef;
    //         if (descriptionElement !== null) {
    //             descriptionElement.focus();
    //         }
    //     }
    // }, [open]);

    useEffect(() => {
        if (contractorAttendance !== undefined && contractorAttendance !== mReqContractorAttendance) {
            setContractorAttendance(contractorAttendance)
            // console.log(contractorAttendance)
        }
    }, [contractorAttendance])

    useEffect(() => {
        if (recruitmentList !== undefined && recruitmentList !== RecruitmentList) {
            setRecruitmentList(recruitmentList)
            // console.log(recruitmentList)
        }
    }, [recruitmentList])

    useEffect(()=>{
        // console.log("RecruitmentList")
        // console.log("計算總數")
        var MonthlySalaryAmount = 0
        var AttendanceDayAmount = 0
        var OvertimePayAmount = 0
        var AbsenceAmout = 0
        var SalaryAddAmount = 0
        var SalarySubtractAmount = 0
        var SalaryAmount = 0
        var PreServiceFeeAmount = 0
        if(RecruitmentList.length > 0){
            recruitmentList.map(recruitment => {
                MonthlySalaryAmount += parseInt(recruitment.BaseSalary)
                AttendanceDayAmount += parseInt(recruitment.AttendanceDay)
                OvertimePayAmount += parseInt(recruitment.OvertimePay)
                AbsenceAmout += parseInt(recruitment.AbsenceAmout)
                SalaryAddAmount += recruitment.SalaryAddAmount
                SalarySubtractAmount += parseInt(recruitment.SalarySubtractAmount)
                SalaryAmount += parseInt(recruitment.Salary)
                PreServiceFeeAmount += parseInt(recruitment.PreServiceFee)
            })
    
            setMonthlySalaryAmount( MonthlySalaryAmount)
            setAttendanceDayAmount(AttendanceDayAmount)
            setOvertimePayAmount(OvertimePayAmount)
            setAbsenceAmout(AbsenceAmout)
            setSalaryAddAmount(SalaryAddAmount)
            setSalarySubtractAmount(SalarySubtractAmount)
            setSalaryAmount(SalaryAmount)
            setPreServiceFeeAmount(PreServiceFeeAmount)
            console.log(RecruitmentList)
        }
    }, [RecruitmentList])

    useEffect(() => {
        mReqContractorAttendance.info.salaryMonthly.DailyWageMonthly = DailyWageMonthly
        recruitmentList.forEach((recruitment, index, arr) => {
            var r = new ReqRecruitmentItem_SalaryMonthly({})
            r.fromJson(recruitment)
            r.setDailyWageMonthly(parseInt(DailyWageMonthly) )
            arr[index] = r
        });
        console.log(recruitmentList)
        setRecruitmentList(JSON.parse(JSON.stringify(recruitmentList)) )
    }, [DailyWageMonthly])

    //提供 RecruitmentBox 執行
    function setRecruitment(mReqRecruitmentItem_SalaryMonthly){
        recruitmentList.forEach((recruitment, index, arr) => {
            if(recruitment.caseContractor === mReqRecruitmentItem_SalaryMonthly.caseContractor){
            arr[index] = mReqRecruitmentItem_SalaryMonthly
            }
        });
        // console.log(recruitmentList)
        setRecruitmentList(JSON.parse(JSON.stringify(recruitmentList)) )
    }


    function setOpenDialog(title, content, action) {
        setDialogTitle(title)
        setDialogContent(content)
        setDialogAction(action)
        setOpen(true)
    }

    function save(){
        console.log(RecruitmentList)
        var contractorAttendance = getReqContractorAttendance()
        // console.log(contractorAttendance)
        toSave(contractorAttendance)
    }

    //送出計算結果
    function send(){
        var contractorAttendance = getReqContractorAttendance()
        var mContractorAttendanceInfo_SalaryMonthly = new ContractorAttendanceInfo_SalaryMonthly({})
        mContractorAttendanceInfo_SalaryMonthly.fromJson(contractorAttendance.info.salaryMonthly)
        mContractorAttendanceInfo_SalaryMonthly.setBaseSalary({
            Amount: MonthlySalaryAmount,
            // Notice,
            // Action,
            ActionTime: moment(new Date()).format('YYYY/MM/DD HH:mm:ss')
        })

        mContractorAttendanceInfo_SalaryMonthly.setSalary({
            Amount: SalaryAmount,
            // Notice,
            // Action,
            ActionTime: moment(new Date()).format('YYYY/MM/DD HH:mm:ss')
        })
        contractorAttendance.info.salaryMonthly = mContractorAttendanceInfo_SalaryMonthly
        console.log(contractorAttendance)
        toSave(contractorAttendance)
    }

    function getReqContractorAttendance(){
        var contractorAttendance = new ReqContractorAttendance({})
        contractorAttendance.fromJson(mReqContractorAttendance)
        contractorAttendance.info.salaryMonthly.RecruitmentList = RecruitmentList
        return contractorAttendance
    }

    function toCancel() {
        setOpen(false)
    }

    var title = <>上工總人數<span className="text-success">{RecruitmentList.length}</span>人</>
    var content =
        <>
            {/* <Button onClick={e=>setOpen(true)}>scroll=paper</Button> */}
            <DailogHtml isOpen={open} sOpen={setOpen} title={dialogTitle} content={dialogContent} action={dialogAction} />
            <div className="row">
                <SingleSelect title={"日薪計算方法"}
                    val={DailyWageMonthly}
                    attr={DailyWageMonthlyAttr}
                    action={setDailyWageMonthly}
                    size={4}
                />
            </div>
            <div className="hr-line-dashed"></div>
            <div id="editable_wrapper" className="form-inline dt-bootstrap">
                <div className="row">
                    <div className="col-sm-12">
                        <table className="table table-striped table-bordered table-hover  dataTable">
                            <thead>
                                <tr role="row">
                                    <th className="text-center sorting col-sm-1">姓名</th>
                                    <th className="text-center sorting col-sm-1">職務</th>
                                    <th className="text-center sorting col-sm-1">底薪</th>
                                    <th className="text-center sorting col-sm-1">出勤天數</th>
                                    <th className="text-center sorting col-sm-1">加班</th>
                                    <th className="text-center sorting col-sm-1">請假</th>
                                    <th className="text-center sorting col-sm-1">加項</th>
                                    <th className="text-center sorting col-sm-1">減項</th>
                                    <th className="text-center sorting col-sm-1">應付</th>
                                    <th className="text-center sorting col-sm-1">服務費-未扣保費</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    RecruitmentList.map((recruitment) => (
                                        <RecruitmentBox key={recruitment.caseContractor}
                                            recruitment={recruitment}
                                            setDialog={setOpenDialog}
                                            setOpen={setOpen}
                                            action={setRecruitment}
                                            getContractor={getContractor}
                                        />
                                    ))
                                }
                                <tr role="row">
                                    <td className="text-center">合計</td>
                                    <td className="text-center"></td>
                                    <td className="text-center"><span className="text-success">{Number(MonthlySalaryAmount).toLocaleString('en-US')}</span></td>
                                    <td className="text-center"><span className="text-success">{AttendanceDayAmount}</span></td>
                                    <td className="text-right"><span className="text-success">{Number(OvertimePayAmount).toLocaleString('en-US')}</span></td>
                                    <td className="text-right"><span className="text-danger">{Number(AbsenceAmout).toLocaleString('en-US')}</span></td>
                                    <td className="text-right"><span className="text-success">{Number(SalaryAddAmount).toLocaleString('en-US')}</span></td>
                                    <td className="text-right"><span className="text-danger">{Number(SalarySubtractAmount).toLocaleString('en-US')}</span></td>
                                    <td className="text-right"><span className="text-success">{Number(SalaryAmount).toLocaleString('en-US')}</span></td>
                                    <td className="text-right"><span className="text-success">{Number(PreServiceFeeAmount).toLocaleString('en-US')}</span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>

    var footer =
        <div className="row">
            <div className="col-sm-12">
                <div className="col-md-3">

                    {/* <SearchButton name={"下載範例CSV檔"} icon={""} /> */}
                </div>

                <div className="col-md-3">
                    {/* <SearchButton name={"上傳CSV檔"} icon={""} /> */}
                </div>
                <SubmitButton name={"送出計算結果"} action={send} isRight={true} />
                <SubmitButton name={"儲存登錄資料"} action={save} isRight={true} />
            </div>
        </div>
    return (
        <>
            <ContentBox title={title} content={content} hasDrawer={false} footer={footer} />
        </>
    )
}


function RecruitmentBox({ recruitment, setDialog, setOpen, action, getContractor }) {
    const [Recruitment, setRecruitment] = useState("")

    const [caseContractor, setCaseContractor] = useState("")
    const [Name, setName] = useState("")
    const [Job, setJob] = useState("")
    const [MonthlySalary, setMonthlySalary] = useState("")
    const [AttendanceDay, setAttendanceDay] = useState(0)
    const [OvertimePay, setOvertimePay] = useState(0)
    const [AbsenceItems, setAbsenceItems] = useState([])
    const [AbsenceAmout, setAbsenceAmout] = useState(0)
    const [SalaryAddItems, setSalaryAddItems] = useState([])
    const [SalaryAddAmount, setSalaryAddAmount] = useState(0)
    const [SalarySubtractItems, setSalarySubtractItems] = useState([])
    const [SalarySubtractAmount, setSalarySubtractAmount] = useState(0)
    const [Salary, setSalary] = useState(0)
    const [PreServiceFee, setPreServiceFee] = useState(0)
    const [init, setInit] = useState(true)

    useEffect(() => {
        if (recruitment !== undefined && recruitment !== Recruitment) {
            // console.log(recruitment)
            setRecruitment(recruitment)
            setCaseContractor(recruitment.caseContractor)
            setName(recruitment.Name)
            setJob(recruitment.Job)
            setMonthlySalary(recruitment.BaseSalary)
            setAttendanceDay(recruitment.AttendanceDay)
            setOvertimePay(recruitment.OvertimePay)
            setAbsenceItems(recruitment.AbsenceItems)
            setAbsenceAmout(recruitment.AbsenceAmout)
            setSalaryAddItems(recruitment.SalaryAddItems)
            setSalaryAddAmount(recruitment.SalaryAddAmount)
            setSalarySubtractItems(recruitment.SalarySubtractItems)
            setSalarySubtractAmount(recruitment.SalarySubtractAmount)
            setSalary(recruitment.Salary)
            setPreServiceFee(recruitment.PreServiceFee)
        }
    }, [recruitment])

    useEffect(()=>{
        if(init){
            setInit(false)
        }else{
            console.log(recruitment)
            var mReqRecruitmentItem_SalaryMonthly = new ReqRecruitmentItem_SalaryMonthly({})
            mReqRecruitmentItem_SalaryMonthly.fromJson(recruitment)
            mReqRecruitmentItem_SalaryMonthly.setOvertimePay(OvertimePay)
            mReqRecruitmentItem_SalaryMonthly.setAbsenceAmout(AbsenceAmout)
            mReqRecruitmentItem_SalaryMonthly.setAbsenceItems(AbsenceItems)
            mReqRecruitmentItem_SalaryMonthly.setSalaryAddItems(SalaryAddItems)
            mReqRecruitmentItem_SalaryMonthly.setSalarySubtractItems(SalarySubtractItems)
            mReqRecruitmentItem_SalaryMonthly.setSalary()
            // console.log(mReqRecruitmentItem_SalaryMonthly)
            action(JSON.parse(JSON.stringify(mReqRecruitmentItem_SalaryMonthly)) )
        }
    },[OvertimePay, AbsenceAmout, SalaryAddAmount, SalarySubtractAmount, /*SalaryAddItems, SalarySubtractItems*/])

    // useEffect(()=>{
    //     console.log(Recruitment)
    // },[Recruitment])

    // useEffect(()=>{
    //     console.log(AbsenceItems)
    // },[AbsenceItems])

    // useEffect(()=>{
    //     console.log(AbsenceAmout)
    // },[AbsenceAmout])

    // useEffect(() => {
    //     if (position !== undefined && position !== mPosition) {
    //         console.log(position)
    //         setCustomerContractId(position.customerContractId)
    //         setCustomerPositionId(position.customerPositionId)
    //         setPosition(position)
    //         setShift(position.shift)
    //         setWageType(position.wageType)
    //         setJobDemand(position.jobDemand)
    //         setWorkPlace(position.workPlace)
    //         setWorkAddress(position.workAddress)
    //     }
    // }, [position])

    function getDetail() {
        // var tokenId = uuid(128, 64)
        // setVal2Token("customerPosition", { customerContractId, customerPositionId }, tokenId)
        // window.location.assign("/CustomerPositionDetail/" + tokenId);
        getContractor(caseContractor)
    }
    function DailogCancel() {
        // console.log("DailogCancel")
        setOpen(false)
    }

    function setDailogAttendanceDay() {
        // console.log(Recruitment)
        var title =
            <>
                <span className="text-success">{Name}</span>
                <span className="text-primary">出勤計算</span>
            </>
        var content = <ContractorAttendanceDailogAttendanceDay obj={recruitment} />
        var action = <CancelButton name={"返回"} action={DailogCancel} submitAction={DailogOvertimePaySubmit} />
        setDialog(title, content, action)
    }

    const OvertimePayRef = useRef()
    const DailogOvertimePaySubmit = () => {
        if (OvertimePayRef.current) {
            OvertimePayRef.current.send()
        }
        setOpen(false)
    }

    const DailogOvertimePaySend = ({ OvertimePay }) => {
        // console.log(OvertimePay)
        setOvertimePay(OvertimePay)
    }

    function setDailogOvertimePay() {
        var title =
            <>
                <span className="text-success">{Name}</span>
                <span className="text-primary">加班金額輸入</span>
            </>
        var content = <ContractorAttendanceDailogOvertimePay obj={OvertimePay} action={DailogOvertimePaySend} ref={OvertimePayRef} />
        var action = <CancelSubmitButton cancelName={"返回"} cancelAction={DailogCancel} submitName={"送出"} submitAction={DailogOvertimePaySubmit} />
        setDialog(title, content, action)
    }

    const AbsenceAmoutRef = useRef()
    const DailogAbsenceAmoutSubmit = () => {
        if (AbsenceAmoutRef.current) {
            AbsenceAmoutRef.current.send()
        }
        setOpen(false)
    }
    const DailogAbsenceAmoutSend = ({ AbsenceItems, AbsenceAmout }) => {
        // console.log(AbsenceItems)
        // console.log(AbsenceAmout)
        setAbsenceItems(JSON.parse(JSON.stringify(AbsenceItems)))
        setAbsenceAmout(AbsenceAmout)
    }
    function setDailogAbsenceAmout() {
        var title =
            <>
                <span className="text-success">{Name}</span>
                <span className="text-primary">請假扣款計算</span>
            </>
        // console.log(Recruitment)
        // console.log(AbsenceItems)
        // console.log(AbsenceAmout)
        var content = <ContractorAttendanceDailogAbsenceAmout obj={JSON.stringify(AbsenceItems) } AbsenceAmout={AbsenceAmout} hourlySalary={Recruitment.hourlySalary} action={DailogAbsenceAmoutSend} ref={AbsenceAmoutRef} />
        var action = <CancelSubmitButton cancelName={"返回"} cancelAction={DailogCancel} submitName={"送出"} submitAction={DailogAbsenceAmoutSubmit} />
        setDialog(title, content, action)
    }

    const SalaryAddAmountRef = useRef()
    const DailogSalaryAddAmountSubmit = () => {
        if (SalaryAddAmountRef.current) {
            SalaryAddAmountRef.current.send()
        }
        setOpen(false)
    }
    const DailogSalaryAddAmountSend = ({ SalaryAddItems, SalaryAddAmount }) => {
        console.log(SalaryAddItems)
        // console.log(AbsenceAmout)
        setSalaryAddItems(JSON.parse(JSON.stringify(SalaryAddItems)))
        setSalaryAddAmount(SalaryAddAmount)
    }
    function setDailogSalaryAddAmount() {
        var title =
            <>
                <span className="text-success">{Name}</span>
                <span className="text-primary">加項計算</span>
            </>
        var content = <ContractorAttendanceDailogSalaryAddAmount obj={JSON.stringify(SalaryAddItems) } SalaryAddAmount={SalaryAddAmount} action={DailogSalaryAddAmountSend} ref={SalaryAddAmountRef} />
        var action = <CancelSubmitButton cancelName={"返回"} cancelAction={DailogCancel} submitName={"送出"} submitAction={DailogSalaryAddAmountSubmit} />
        setDialog(title, content, action)
    }

    const SalarySubtractAmountRef = useRef()
    const DailogSalarySubtractAmountSubmit = () => {
        if (SalarySubtractAmountRef.current) {
            SalarySubtractAmountRef.current.send()
        }
        setOpen(false)
    }
    const DailogSalarySubtractAmountSend = ({ SalarySubtractItems, SalarySubtractAmount }) => {
        console.log(SalarySubtractItems)
        // console.log(AbsenceAmout)
        setSalarySubtractItems(JSON.parse(JSON.stringify(SalarySubtractItems)))
        setSalarySubtractAmount(SalarySubtractAmount)
    }
    function setDailogSalarySubtractAmount() {
        var title =
            <>
                <span className="text-success">{Name}</span>
                <span className="text-primary">減項計算</span>
            </>
        var content = <ContractorAttendanceDailogSalarySubtractAmount obj={JSON.stringify(SalarySubtractItems) } SalarySubtractAmount={SalarySubtractAmount} action={DailogSalarySubtractAmountSend} ref={SalarySubtractAmountRef} />
        var action = <CancelSubmitButton cancelName={"返回"} cancelAction={DailogCancel} submitName={"送出"} submitAction={DailogSalarySubtractAmountSubmit} />
        setDialog(title, content, action)
    }

    return (
        <>
            <tr role="row">
                <td className="text-center"><a href="#A" onClick={e => getDetail()}>{Name}</a>&nbsp;</td>
                <td className="text-center">{Job}</td>
                <td className="text-center">{Number(MonthlySalary).toLocaleString('en-US')}</td>
                <td className="text-center"><a href="#A" onClick={e => setDailogAttendanceDay()}>{AttendanceDay}</a></td>
                <td className="text-right"><a href="#A" onClick={e => setDailogOvertimePay()}>{Number(OvertimePay).toLocaleString('en-US')}</a></td>
                <td className="text-right"><a href="#A" onClick={e => setDailogAbsenceAmout()}>{Number(AbsenceAmout).toLocaleString('en-US')}</a></td>
                <td className="text-right"><a href="#A" onClick={e => setDailogSalaryAddAmount()}>{Number(SalaryAddAmount).toLocaleString('en-US')}</a></td>
                <td className="text-right"><a href="#A" onClick={e => setDailogSalarySubtractAmount()}>{Number(SalarySubtractAmount).toLocaleString('en-US')}</a></td>
                <td className="text-right">{Salary}</td>
                <td className="text-right">{PreServiceFee}</td>
            </tr>
        </>
    )
}
